import {Component} from '@angular/core';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Observable} from "rxjs";
import {filter, first, flatMap} from "rxjs/operators";
import {User} from "./dtos/user";
import {Router} from "@angular/router";

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  lamUser$: Observable<User | null>;

  constructor(public afAuth: AngularFireAuth, private db: AngularFirestore, public router: Router) {
    this.lamUser$ = afAuth.user.pipe(
      filter(u => u != null),
      flatMap(authUser => this.db.doc<User>(`users/${authUser.uid}`).valueChanges().pipe(first()))
    );
    $(document).on("shown.bs.dropdown", function () {
      var $ul = $("#theDropdown");
      var $button = $("#dropdownButton");
      var ulOffset = $ul.offset();
      if (Math.abs(ulOffset.left + $button.width() - $(window).width()) < 100)
        $ul.addClass("dropdown-menu-right");

    }).on("hidden.bs.dropdown", ".dropdown", function() {
      $("#theDropdown").removeClass("dropdown-menu-right");
    });

  }

  signOut() {
    this.afAuth.signOut();
    this.router.navigateByUrl('home');
  }
}
